/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { FileInfo } from '@progress/kendo-angular-upload';

import { AppAliasService } from '..';
import { GeoJsonFeature, Site, WizardStep } from '../../../models';
import { BasicDropdownValue } from '../../../models/basic-dropdown-value';
import { AliasesDefaultValues, SiteTypeNames, SiteTypes } from '../../../shared/enums';

/* istanbul ignore file */
export class SiteFormLogicServiceModel {
    siteForm: UntypedFormGroup = new UntypedFormGroup({
        siteType: new UntypedFormControl(SiteTypes.Point, [Validators.required]),
        address: new UntypedFormControl(null),
        city: new UntypedFormControl(null),
        state: new UntypedFormControl(null),
        zipCode: new UntypedFormControl(null),
        latitude: new UntypedFormControl(null),
        longitude: new UntypedFormControl(null),
        siteName: new UntypedFormControl(null),
        siteNo: new UntypedFormControl(null),
        chargeNumber: new UntypedFormControl(null),
        active: new UntypedFormControl(false)
    });

    geoJsonFiles: FileInfo[] = [];
    geoJson: GeoJsonFeature | undefined = undefined;
    geoJsonFileName: string | undefined = undefined;
    geoJsonErrorText: string | undefined = '';
    hasGeoJsonChanged: boolean = false;
    changedInputControl: string = '';
    initialSiteNumber: string = '';
    isNewSite: boolean = true;
    updatedSite: Site = new Site();
    searchType: SearchType = SearchType.ADDRESS;
    applySiteTemplate: boolean = false;
    wizardSteps: WizardStep[] = [
        new WizardStep(`Location`, 'location_on'),
        new WizardStep(`Details`, 'description'),
        new WizardStep('Review & Submit', 'check')
    ];

    siteTemplateWizardSteps: WizardStep[] = [
        new WizardStep(`Location`, 'location_on'),
        new WizardStep(`Details`, 'description'),
        new WizardStep(`${this.siteAlias} Template`, 'space_dashboard'),
        new WizardStep('Review & Submit', 'check')
    ];

    currentWizardStep: number = 0;
    locationSummary = new Map<string, string>();
    detailsSummary = new Map<string, string>();
    wizardStepErrorMap = new Map<number, boolean>([[0, true], [1, true]]);
    keyWordMap: Map<string, string> = new Map<string, string>([
        ['siteType', `${this.siteAlias} Type`],
        ['zipCode', `Zip Code`],
        ['siteName', `${this.siteAlias} Name`],
        ['siteNo', `${this.siteAlias} Number`],
        ['active', `Activate ${this.siteAlias} on Creation`],
        ['chargeNumber', 'Charge Number'],
        ['applySiteTemplate', `${this.siteAlias} Template`]
    ]);

    valueWordMap: Map<any, string> = new Map<any, string>([
        [true, `Yes`],
        [false, `No`]
    ]);

    firstWizardStepHeight: number = 0;
    siteNumberExists: boolean = false;
    isActivateRadioDisabled: boolean = true;
    selectedSiteTemplateId: string | null = null;
    siteLocationDefinitionTypes: BasicDropdownValue[] = [
        { name: SiteTypeNames.Point, id: SiteTypes.Point },
        { name: SiteTypeNames.LineArea, id: SiteTypes.LineArea }
    ];

    isAppEnterprise: boolean = false;

    get siteAlias(): string {
        return this._appAliasService?.siteAlias ?? AliasesDefaultValues.SingularSite;
    }

    constructor(private _appAliasService: AppAliasService | undefined) { }
}

export enum SiteFormInputControl {
    ADDRESS = 'address',
    CITY = 'city',
    STATE = 'state',
    SITE_TYPE = 'siteType',
    SEARCH_TYPE = 'searchType',
    ZIP_CODE = 'zipCode',
}

export enum SearchType {
    ADDRESS = 'address',
    LAT_LONG = 'lat/long',
}

export interface SiteFormValues {
    siteName: string | null;
    siteNo: string | null;
    address: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    active: boolean | null;
    latitude: number | null;
    longitude: number | null;
    chargeNumber: string | null;
}
